import { toast } from "react-toastify";
import { BasicPage } from "../../../theme/Component/BasicPage"
import { ListMenu } from "../../../theme/Component/ListMenu";
import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _single, _Technicians } from "../../../../core/services/dataBean/EntityCatalog";
import { BasicTable, MASK_MONEY } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { AccountEditor } from "../../../editor/AccountEditor";
import useModal, { MODAL_md, MODAL_XL } from "../../../theme/Component/hooks/useModal";
import { RequestMaintenance } from "../RequestMaintenance/RequestMaintenance";
import { TechnicianAssignment } from "./TechnicianAssignment/TechnicianAssignment";
import { SelectTechnicianExperticies } from "../TechnicianExperticies/SelectTechnicianExperticies";
import usePaginator from "../../../theme/Component/usePaginator";
import { InputMoney } from "../../../theme/Input/InputMoney";

interface Form {
    State: number;
    Location: number;
}

export const Technicians = () => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_Technicians);
    const paginator = usePaginator();

    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Eliminar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const modalAssings = useModal(`Asignaciones de ${bean.TechnicianName}`, MODAL_md);
    const modalHistory = useModal(`Historial de Mantenimientos de ${bean.TechnicianName}`, MODAL_XL);

    useEffect(() => {
        getLista();
    }, [paginator.page])

    const getLista = () => {
        const props = {
            State: 1
        }

        instance.getTechniciansRender(paginator.page, 15, props).then(
            (resp: any) => {
                paginator.setPages(resp.NumberOfPages);
                paginator.setRecords(resp.NumberOfPages * 15);

                resp.List.forEach((item: any) => {
                    const pad = (num: number) => num.toString().padStart(2, '0');

                    if (!item.DataBeanProperties) {
                        item.DataBeanProperties = {};
                    }

                    item.DataBeanProperties.EntityUser = item.DataBeanProperties.IDAccountTechnician ? `${item.DataBeanProperties.NitTechnician ?? ""} - ${item.DataBeanProperties.TechnicianEntityName ?? ""}` : "N/A";
                    item.DataBeanProperties.HoraEntrada = `${pad(item.DataBeanProperties.WorkShiftFromH ?? 0)}:${pad(item.DataBeanProperties.WorkShiftFromM ?? 0)}`;
                    item.DataBeanProperties.HoraSalida = `${pad(item.DataBeanProperties.WorkShiftToH ?? 0)}:${pad(item.DataBeanProperties.WorkShiftToM ?? 0)}`;
                });

                setLista(resp.List);
            }
        ).catch(err => {
            toast.error("Error al cargar la lista de técnicos");
        });
    };

    const create = () => {
        setBean({
            State: 1,
            IDEmployee: _single.getAccountID(),
        });
        setModal({ ...modal, "name": `Agregar tecnico de mantenimiento`, "view": true });
    }

    const deleteItem = () => {
        const x = { ...bean, State: 3 };
        editaItem(x);
        setModalC({ ...modalC, view: false });
    };

    const editaItem = (obj: any) => {
        //console.log(abilityType.bean);
        instance.updateTechnicians(obj).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const head = [
        { title: 'ID', property: 'IDTechnicians', visible: true },
        { title: 'Código', property: 'CodeTechnician', visible: true },
        { title: 'Tecnico', property: 'EntityUser', visible: true },
        { title: 'Hora Entrada', property: 'HoraEntrada', visible: true },
        { title: 'Hora Salida', property: 'HoraSalida', visible: true },
        { title: 'Experticie', property: 'ExperticeName', visible: true },
        { title: 'Costo/Hora', property: 'ValuePerHour', visible: true, mask: MASK_MONEY },
        { title: 'Habilidades', property: 'JSONAbilities', visible: true },
    ];


    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },
            { titulo: 'Historial de Mantenimientos', icono: 'ri-history-line', visible: true, evento: () => { modalHistory.open() } },
            { titulo: 'Agenda del Usuario', icono: 'ri-user-follow-line', visible: true, evento: () => { modalAssings.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <BasicPage titulo="Lista de Tecnicos">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable
                        body={lista}
                        head={head}
                        rowSet={setBean}
                        listButtons={listaBotones()}
                        iconButtons={iconButtonsItem}
                        pageTop={paginator.page}
                        next={paginator.next}
                        back={paginator.back}
                        records={paginator}
                    />

                    <Modal modal={modal} updateModal={setModal} eventModal={() => { editaItem(bean) }}>
                        <div className="row">
                            <div className="col-md-12">
                                <AccountEditor idAccount={bean.IDAccountTechnician} label="Tecnico de Turno" onChange={(e) => { setBean({ ...bean, IDAccountTechnician: e.IDAccount, TechnicianName: e.EntityName, TechnicianNit: e.Nit }); console.log(e) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Código</label>
                                <input type="text" className="form-control" value={bean.CodeTechnician} onChange={(e) => { setBean({ ...bean, CodeTechnician: e.target.value }) }} />
                            </div>
                            <div className="col-md-12">
                                <SelectTechnicianExperticies idSelector={bean.IDTechnicianExperticies} onChange={(e) => { setBean({ ...bean, IDTechnicianExperticies: e.IDTechnicianExperticies, RenderTechnicianExperticies: e.Name, ValuePerHour: e.ValueHour }) }} label="Experticie" returnType="Object" />
                            </div>

                            <div className="col-md-12">
                                <InputMoney _value={bean.ValuePerHour} onChange={(e) => { setBean({ ...bean, ValuePerHour: e }) }} _label="Valor/Hora" />
                            </div>

                            <div className="col-md-12">
                                <label>Habilidades</label>
                                <textarea className="form-control" value={bean.JSONAbilities} onChange={(e) => { setBean({ ...bean, JSONAbilities: e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Hora de Entrada</label>
                                <div className="row">
                                    <div className="col-md-6">
                                        <select
                                            className="form-control"
                                            value={bean.WorkShiftFromH ?? ""}
                                            onChange={(e) => setBean({ ...bean, WorkShiftFromH: parseInt(e.target.value) })}
                                        >
                                            <option value="">HH</option>
                                            {[...Array(24)].map((_, i) => (
                                                <option key={i} value={i}>{i.toString().padStart(2, '0')}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-6">
                                        <select
                                            className="form-control"
                                            value={bean.WorkShiftFromM ?? ""}
                                            onChange={(e) => setBean({ ...bean, WorkShiftFromM: parseInt(e.target.value) })}
                                        >
                                            <option value="">MM</option>
                                            {[...Array(12)].map((_, i) => (
                                                <option key={i * 5} value={i * 5}>{(i * 5).toString().padStart(2, '0')}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <label>Hora de Salida</label>
                                <div className="row">
                                    <div className="col-md-6">
                                        <select
                                            className="form-control"
                                            value={bean.WorkShiftToH ?? ""}
                                            onChange={(e) => setBean({ ...bean, WorkShiftToH: parseInt(e.target.value) })}
                                        >
                                            <option value="">HH</option>
                                            {[...Array(24)].map((_, i) => (
                                                <option key={i} value={i}>{i.toString().padStart(2, '0')}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-6">
                                        <select
                                            className="form-control"
                                            value={bean.WorkShiftToM ?? ""}
                                            onChange={(e) => setBean({ ...bean, WorkShiftToM: parseInt(e.target.value) })}
                                        >
                                            <option value="">MM</option>
                                            {[...Array(12)].map((_, i) => (
                                                <option key={i * 5} value={i * 5}>{(i * 5).toString().padStart(2, '0')}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </Modal>

                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {bean.TechnicianName}</strong>
                    </ModalConfirm>

                    <Modal modal={modalHistory.modal} updateModal={modalHistory.setModal} >
                        <div className="row">
                            <div className="col-md-12">
                                <RequestMaintenance isModal filterProps={{ IDTechnicians: bean.IDTechnicians }} />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalAssings.modal} updateModal={modalAssings.setModal} >
                        <TechnicianAssignment _Technician={bean} />
                    </Modal>
                </div>
            </div>
        </BasicPage>
    )
}